import { useCallback, useEffect, useState } from 'react';

// Matches the backend resend cooldown.
export const RESEND_COOLDOWN_SECONDS = 30;

const useResendCooldown = () => {
    const [secondsLeft, setSecondsLeft] = useState(0);

    useEffect(() => {
        if (secondsLeft <= 0) return undefined;
        const id = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
        return () => clearTimeout(id);
    }, [secondsLeft]);

    const start = useCallback(() => setSecondsLeft(RESEND_COOLDOWN_SECONDS), []);
    const reset = useCallback(() => setSecondsLeft(0), []);

    return { secondsLeft, isCoolingDown: secondsLeft > 0, start, reset };
};

export default useResendCooldown;
